import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=6e4b545e"
import script from "./thirdStep.vue?vue&type=script&lang=ts"
export * from "./thirdStep.vue?vue&type=script&lang=ts"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=6e4b545e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports